import { AxiosInstance } from 'axios';
import { ScenarioRunPreflightCheck } from './api';

/** What the pre-flight checks found, asked for from the picker. Mirrors ScenarioPreflightReport. */
export interface ScenarioPreflightReport {
    customer?: string;
    environment?: string;
    checkedAtUtc?: string;
    checks?: ScenarioRunPreflightCheck[];
}

/**
 * Makes the checks a run would make before its first scenario, without starting one.
 *
 * Written by hand next to the generated client, like the other endpoints that arrived after it was last
 * regenerated. An empty selection checks the whole suite, which is what the picker asks for: the answer then says
 * for every scenario whether a run would get to it.
 */
export const checkScenarioPreflight = async (
    axios: AxiosInstance,
    customer: string,
    environment: string,
    suite?: string,
    only: string[] = []
): Promise<ScenarioPreflightReport> => {
    const response = await axios.post(
        `/ScenarioRun/${encodeURIComponent(customer)}/${encodeURIComponent(
            environment
        )}/preflight`,
        { suite, only, skip: [], dryRun: false },
        { headers: { 'Content-Type': 'application/json' } }
    );

    // The axios instance is created with transformResponse: [], so response.data is a
    // string and has to be parsed here.
    return typeof response.data === 'string'
        ? (JSON.parse(response.data) as ScenarioPreflightReport)
        : (response.data as ScenarioPreflightReport);
};
